(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Use event delegation so handlers survive Shopify editor re-renders
    document.addEventListener('click', function(e) {
      // Handle tab-title clicks (desktop tab switching)
      const tabTitle = e.target.closest('.tab-title');
      if (tabTitle) {
        e.preventDefault();
        if (tabTitle.classList.contains('is-active')) return;
        const section = tabTitle.closest('.section-product-tabs');
        if (!section) return;
        const allTitles = section.querySelectorAll('.tab-title');
        const allContents = section.querySelectorAll('.tab-content');
        allTitles.forEach(t => t.classList.remove('is-active'));
        allContents.forEach(c => c.classList.remove('is-active'));
        tabTitle.classList.add('is-active');
        const idx = Array.from(allTitles).indexOf(tabTitle);
        if (allContents[idx]) {
          setTimeout(() => {
            allContents[idx].classList.add('is-animating');
            allContents[idx].classList.add('is-active');
            allContents[idx].addEventListener('transitionend', function handler() {
              allContents[idx].classList.remove('is-animating');
              allContents[idx].removeEventListener('transitionend', handler);
            });
          }, 10);
        }
        return;
      }

      // Handle toggle-link clicks (accordion/mobile toggle)
      const toggleLink = e.target.closest('.toggle-link');
      if (!toggleLink) return;

      const toggleTitle = toggleLink.closest('.toggle-title');
      if (!toggleTitle) return;

      const viewContentType = toggleTitle.dataset.viewContent;
      const contentEl = toggleTitle.nextElementSibling;
      if (!contentEl || !contentEl.classList.contains('toggle-content')) return;

      // Extract only the text label
      const textSpan = toggleLink.querySelector('.text');
      const titleText = textSpan ? textSpan.textContent.trim() : '';

      if (viewContentType === 'sidebar') {
        // Inject into the sidebar drawer using innerHTML to avoid CSS inheritance
        const drawer = document.querySelector('#Global-Drawer');
        if (!drawer) return;

        const drawerWrapper = drawer.querySelector('.drawer__wrapper');
        const tabTitleTextEl = drawer.querySelector('.tab-title-text');

        if (tabTitleTextEl) {
          tabTitleTextEl.textContent = titleText;
        }

        if (drawerWrapper) {
          // Use innerHTML — avoids cloneNode CSS inheritance issues
          drawerWrapper.innerHTML = '<div class="rte" style="padding:1.5rem 0;">' + contentEl.innerHTML + '</div>';
          renderVideo();
        }

        // Let the event bubble to SideDrawerOpener which opens the drawer
        return;

      } else if (viewContentType === 'popup') {
        const popupContent = document.querySelector('.popup-content-wrapper');
        if (popupContent) {
          popupContent.innerHTML = '<div class="rte" style="padding:1.5rem 0;">' + contentEl.innerHTML + '</div>';
          renderVideo();
        }
        // Let the event bubble to SideDrawerOpener which opens the popup
        return;

      } else {
        // Default/inline mode — toggle content visibility
        e.preventDefault();
        e.stopPropagation();

        const isOpen = toggleTitle.classList.toggle('is-open');

        // Explicitly set styles on the content element (don't rely on CSS nesting)
        if (isOpen) {
          contentEl.style.height = 'auto';
          contentEl.style.overflow = 'visible';
          contentEl.style.opacity = '1';
          contentEl.style.display = 'block';
          contentEl.style.padding = '15px 0';
        } else {
          contentEl.style.height = '0';
          contentEl.style.overflow = 'hidden';
          contentEl.style.opacity = '0';
          contentEl.style.display = '';
          contentEl.style.padding = '0';
        }
      }
    }, true); // capture phase
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();
})();
